<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="8" :sm="24">
            <a-form-item label="期间" prop="forecastPeriodTem">
              <a-range-picker
                :placeholder="['开始日期', '结束日期']"
                valueFormat="YYYY-MM"
                format="YYYY-MM"
                :value="queryParams.forecastPeriodTem"
                :mode="mode"
                @panelChange="handlePanelChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="事业部" prop="listBusiness">
              <global-select
                :value.sync="queryParams.listBusiness"
                selectType="selectMultiple"
                requestApi="/scp/scpSopShipmentForecast/listBusiness"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <div class="bt-wrapper">
        <a-button type="primary" @click="handleExport">导出报表</a-button>
        <span >金额单位;万元</span>
      </div>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :pagination="false"
          @successCallBack="successCallBack"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
        >
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

        <script>
    import { apiDeleteShipmentForecast, apiListRollingReport } from '@/api/scp/shipmentForecast/shipmentForecastManagement'
    import { generateLsTableResData } from '@/utils/util.js'
    import moment from 'moment';

    export default {
      // eslint-disable-next-line
      name: 'earningReport',
      components: {},
      data () {
        return {
          mode: ['month', 'month'],
          // 表格多选
          selectedRowKeys: [],
          selectedRows: [],
          // 表格配置
          tableProps: {
            requestApi: generateLsTableResData(apiListRollingReport, true),
            pageCurrent: true
          },
          // 查询参数
          queryParams: {
            id: '',
            forecastPeriodTem: undefined,
            demandDepartment: undefined,
            start: '',
            end: '',
            listBusiness: []
          },
          baseUomFlagOptions: [
            {
              dictLabel: '是',
              dictValue: 'Y'
            },
            {
              dictLabel: '否',
              dictValue: 'N'
            }
          ],
          // 表格字段
          columns: [
          ]
        }
      },
      created () {
        this.queryParams.id = this.$route.query.id; // 从路由参数中获取 id 值
        this.queryParams.listBusiness = [ this.$route.query.demandDepartment ]
        this.queryParams.start = this.formattedDate(this.$route.query.forecastPeriodFrom)
        this.queryParams.end = this.formattedDate(this.$route.query.forecastPeriodTo)
        this.queryParams.forecastPeriodTem = [moment(this.queryParams.start).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'), moment(this.queryParams.end).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')]
      },
      mounted () {
       // this.onSearch()
       this.getRollingReportList()
      },
      methods: {
        formattedDate (originalDate) {
          const year = originalDate.slice(0, 4);
          const month = originalDate.slice(4); // 提取月份部分，例如："05"
          const date = moment([year, month - 1, 1]);

          return date.format('YYYY-MM-DD');
        },
        successCallBack () {
          this.queryParams.id = ''
        },
        /** 导出按钮操作 */
      handleExport () {
        if (!this.queryParams.forecastPeriodTem) {
          this.$message.error('期间不能为空')
          return
       }
       if (!this.queryParams.listBusiness) {
          this.$message.error('事业部不能为空')
          return
       }
        this.download('scp/scpSopShipmentForecast/exportRollingReport', {
          ...this.queryParams
        }, `滚动业绩报表_${new Date().getTime()}.xlsx`)
      },
        getRollingReportList () {
          this.columns = []
          apiListRollingReport({ ...this.queryParams }).then((response) => {
            if (response.code === 200) {
             const titleList = response.data.title
             // 使用 forEach 方法
                titleList.forEach(item => {
                  const columnsItem = {
                    title: item.indexName,
                    dataIndex: item.indexKey,
                    ellipsis: true,
                    align: item.indexKey === 'name' ? 'left' : 'center'
                  }
                  this.columns.push(columnsItem);
                });
                const dataList = response.data.data
                this.$refs.dataTable.myDataSource = dataList
            } else {
              this.$message.error(response.msg)
            }
          })
        },
        resetQuery () {
          this.queryParams.listBusiness = undefined
          this.queryParams.forecastPeriodTem = ''
          this.queryParams.start = ''
          this.queryParams.end = ''
        },
        handlePanelChange (value, mode) {
      const yearMonth1 = value[0].format('YYYY-MM')
      const yearMonth2 = value[1].format('YYYY-MM')
      this.queryParams.start = yearMonth1 + '-01'
      this.queryParams.end = yearMonth2 + '-01'
      this.queryParams.forecastPeriodTem = value
      },
        deleteShipmentForecast (record) {
          apiDeleteShipmentForecast(record.id).then((response) => {
            if (response.code === 200) {
              this.$message.success('删除成功')
              this.onSearch()
            } else {
              this.$message.error(response.msg)
            }
          })
        },
        /** 行选中 */
        selectedRowChange (selectedRowKeys, selectedRows) {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        // 表单搜索
        onSearch () {
          if (!this.queryParams.forecastPeriodTem) {
            this.$message.error('期间未选择')
            return
          }
          if (!this.queryParams.listBusiness) {
            this.$message.error('事业部未选择')
            return
          }
          // this.$refs.dataTable.searchParams = this.queryParams
          // this.$refs.dataTable.getData()
          this.getRollingReportList()
        },
        // 取消
        handleCancel (record) {},
        statusOnChange (record) {
          record.netSubInventory = record.netSubInventory === 'Y' ? 'N' : 'Y'
        }
      }
    }
    </script>

        <style scoped lang="less">
    .ml10 {
      margin-left: 10px;
    }
    .ml20 {
      margin-left: 10px;
    }
    .ml70 {
      margin-left: 70px;
    }.bt-wrapper{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    </style>
